import { useState, useCallback } from 'react';

// Services

import OptionsService from '../services/options.service';

export default function GetSectorsByState() {
    const [getSectorsIsLoading, setGetSectorsIsLoading] = useState(false);
    const [getSectorsError, setGetSectorsError] = useState(null);
    const [sectors, setSectors] = useState([]);

    // Get the Sectors by State

    const handleGetSectorsByState = useCallback(async (state) => {
        setGetSectorsIsLoading(true);
        setGetSectorsError(null);

        try {
            const sectorsRequest = await OptionsService.getSectorsByState(state);

            setGetSectorsIsLoading(false);
            setSectors(sectorsRequest?.data?.data);

        } catch(error) {    

            setGetSectorsIsLoading(false);
            setGetSectorsError(error.response?.data?.message || error.message);

        }
    }, []);

    return {
        getSectorsIsLoading,
        getSectorsError,
        sectors,
        handleGetSectorsByState,
        setSectors,
    }
}
